var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H15C16.6569 0 18 1.34315 18 3V15C18 16.6569 16.6569 18 15 18H3C1.34315 18 0 16.6569 0 15V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1H3C1.89543 1 1 1.89543 1 3V15C1 16.1046 1.89543 17 3 17H15C16.1046 17 17 16.1046 17 15V3C17 1.89543 16.1046 1 15 1ZM3 0C1.34315 0 0 1.34315 0 3V15C0 16.6569 1.34315 18 3 18H15C16.6569 18 18 16.6569 18 15V3C18 1.34315 16.6569 0 15 0H3Z",
    fill: "#1e3e7c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31212 12.9999C8.17386 12.9999 8.04108 12.9437 7.94302 12.8432L5.15294 9.98405C4.94902 9.77517 4.94902 9.43637 5.15294 9.22738C5.35676 9.01838 5.68744 9.01826 5.89125 9.22738L8.29068 11.686L13.0884 6.17868C13.2804 5.95846 13.6104 5.93901 13.8256 6.13587C14.0407 6.33274 14.0595 6.67096 13.8674 6.89141L8.70155 12.8211C8.60595 12.9309 8.47037 12.9954 8.32687 12.9997C8.32195 12.9998 8.31704 12.9999 8.31212 12.9999Z",
    fill: "#1e3e7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedOutlineIcon);
export default __webpack_public_path__ + "static/media/CheckedOutlineIcon.ccd71a273260cb13c91453d8c3c5db1a.svg";
export { ForwardRef as ReactComponent };